"use client";
import { lazy, useState, useRef } from "react";
import Image from "next/image";
import Img1 from "@/assets/life/life-at-msu.png";
const VideoModal = lazy(() => import('@/components/videoModel'));
import workshops1 from "@/assets/life/workshops-1.png"
import workshops2 from "@/assets/life/workshops-2.png"
import workshops3 from "@/assets/life/workshops-3.png"
import workshops4 from "@/assets/life/workshops-4.png"

import Club1 from "@/assets/life/club-1.png"
import Club2 from "@/assets/life/club-2.png"
import Club3 from "@/assets/life/club-3.png"
import Club4 from "@/assets/life/club-4.png"

import sport1 from "@/assets/life/sport-1.png"
import sport2 from "@/assets/life/sport-2.png"
import sport3 from "@/assets/life/sport-3.png"
import sport4 from "@/assets/life/sport-4.png"

import fests1 from "@/assets/life/fests-1.png"
import fests2 from "@/assets/life/fests-2.png"
import fests3 from "@/assets/life/fests-3.png"
import fests4 from "@/assets/life/fests-4.png"

import community1 from "@/assets/life/community-1.png"
import community2 from "@/assets/life/community-2.png"
import community3 from "@/assets/life/community-3.png"
import community4 from "@/assets/life/community-4.png"
import { Play, PlayIcon } from "lucide-react";

const ClassroomSection = () => {
  const [modal, setModal] = useState({ open: false, url: "" });
  const buttonsContainerRef = useRef(null);

  const data = [
    {
      cat: "Classroom",
      categoryImages: [
        {
          src: Img1, alt: "Classroom", isVideo: true,
          url: 'https://cdn.msu.edu.in/msu-reavamp/videos/Workshop.mp4'
        },
        { src: workshops1, alt: "Classroom" },
        { src: workshops2, alt: "Classroom" },
        { src: workshops3, alt: "Classroom" },
        { src: workshops4, alt: "Classroom" },
      ],
    },
    {
      cat: "Conference room",
      categoryImages: [
        {
          src: Img1, alt: "Conference room", isVideo: true,
          url: 'https://cdn.msu.edu.in/msu-reavamp/videos/MSU_Clubs_Societies.mp4'
        },
        { src: Club1, alt: "Conference room" },
        { src: Club2, alt: "Conference room" },
        { src: Club3, alt: "Conference room" },
        { src: Club4, alt: "Conference room" },
      ],
    },
    {
      cat: "Seminar hall",
      categoryImages: [
        { src: Img1, alt: "Seminar hall", isVideo: true, url: '' },
        { src: sport1, alt: "Seminar hall" },
        { src: sport2, alt: "Seminar hall" },
        { src: sport3, alt: "Seminar hall" },
        { src: sport4, alt: "Seminar hall" },
      ],
    },
    {
      cat: "Fests",
      categoryImages: [
        {
          src: Img1, alt: "Fests", isVideo: true,
          url: 'https://cdn.msu.edu.in/msu-reavamp/videos/Annual+Fest.mp4'
        },
        { src: fests1, alt: "Fests" },
        { src: fests2, alt: "Fests" },
        { src: fests3, alt: "Fests" },
        { src: fests4, alt: "Fests" },
      ],
    },
    {
      cat: "Library",
      categoryImages: [
        { src: Img1, alt: "Library", isVideo: true, url: '' },
        { src: community1, alt: "Library" },
        { src: community2, alt: "Library" },
        { src: community3, alt: "Library" },
        { src: community4, alt: "Library" },
      ],
    },
    {
      cat: "Wi-fi & LMS",
      categoryImages: [
        { src: Img1, alt: "Wi-fi & LMS", isVideo: true, url: '' },
        { src: community1, alt: "Wi-fi & LMS" },
        { src: community2, alt: "Wi-fi & LMS" },
        { src: community3, alt: "Wi-fi & LMS" },
        { src: community4, alt: "Wi-fi & LMS" },
      ],
    },
    {
      cat: "Doctor's Chamber",
      categoryImages: [
        { src: Img1, alt: "Doctor's Chamber", isVideo: true, url: '' },
        { src: community1, alt: "Doctor's Chamber" },
        { src: community2, alt: "Doctor's Chamber" },
        { src: community3, alt: "Doctor's Chamber" },
        { src: community4, alt: "Doctor's Chamber" },
      ],
    },
    {
      cat: "Doctor's Chamber",
      categoryImages: [
        { src: Img1, alt: "Doctor's Chamber", isVideo: true, url: '' },
        { src: community1, alt: "Doctor's Chamber" },
        { src: community2, alt: "Doctor's Chamber" },
        { src: community3, alt: "Doctor's Chamber" },
        { src: community4, alt: "Doctor's Chamber" },
      ],
    },
    {
      cat: "Courses",
      categoryImages: [
        { src: Img1, alt: "Courses", isVideo: true, url: '' },
        { src: community1, alt: "Courses" },
        { src: community2, alt: "Courses" },
        { src: community3, alt: "Courses" },
        { src: community4, alt: "Courses" },
      ],
    },
    {
      cat: "Doctor's Chamber",
      categoryImages: [
        { src: Img1, alt: "Doctor's Chamber", isVideo: true, url: '' },
        { src: community1, alt: "Doctor's Chamber" },
        { src: community2, alt: "Doctor's Chamber" },
        { src: community3, alt: "Doctor's Chamber" },
        { src: community4, alt: "Doctor's Chamber" },
      ],
    },
  ];

  const scrollButtonIntoCenter = (index) => {
    const container = buttonsContainerRef.current;
    const button = container?.children[index];
    if (!button) return;

    requestAnimationFrame(() => {
      button.scrollIntoView({ inline: "center", behavior: "smooth" });
    });
  };

  const scrollLeft = () => {
    if (buttonsContainerRef.current) {
      buttonsContainerRef.current.scrollBy({
        left: -200,
        behavior: 'smooth',
      });
    }
  };

  const scrollRight = () => {
    if (buttonsContainerRef.current) {
      buttonsContainerRef.current.scrollBy({
        left: 200,
        behavior: 'smooth',
      });
    }
  };

  const [activeCategory, setActiveCategory] = useState(data[0].cat);
  const activeImages = data.find((d) => d.cat === activeCategory)?.categoryImages || [];

  return (
    <section className="w-full text-black ">
      <VideoModal
        open={modal.open}
        url={modal.url}
        onClose={() => setModal({ open: false, url: "" })}
      />
      <div className="relative mb-2 flex items-center">
        <div
          className="flex gap-3 overflow-x-auto pb-4 flex-grow scrollbar-hide mb-2"
          ref={buttonsContainerRef}
        >
          {data.map((item, i) => {
            const isLast = i === data.length - 1;

            return (
              <button
                key={i}
                onClick={() => {
                  setActiveCategory(item.cat);
                  scrollButtonIntoCenter(i);
                }}
                className={`cursor-pointer whitespace-nowrap border border-[#FFFFFF33] px-6 py-2 
            text-[15px] md:text-[18px] text-black border border-gray-200 font-medium transition-all duration-300 ${activeCategory === item.cat
                    ? "bg-[#FFA500] text-black border-gray-20"
                    : "bg-transparent hover:bg-[#FFA500] hover:text-black"
                  } ${isLast ? "max-w-[110px] overflow-hidden text-ellipsis" : ""}`}
                style={{ fontFamily: "saans-medium" }}
              >
                {item.cat}
              </button>
            );
          })}
        </div>

        <div className="absolute bg-white py-2 right-0 top-0 flex gap-2">
          <button
            onClick={scrollLeft}
            className="w-8 h-8 flex items-center justify-center border cursor-pointer border-gray-300 rounded-full text-black bg-white shadow-md hover:bg-gray-100 transition-colors text-sm"
            aria-label="Scroll tabs left"
          >
            &lt;
          </button>
          <button
            onClick={scrollRight}
            className="w-8 h-8 flex items-center justify-center cursor-pointer border border-gray-300 rounded-full text-black bg-white shadow-md hover:bg-gray-100 transition-colors text-sm"
            aria-label="Scroll tabs right"
          >
            &gt;
          </button>
        </div>
      </div>

      <p
        className="md:text-[16px] text-black mb-4 text-base"
        style={{ fontFamily: "saans-regular" }}
      >
        Enjoy learning and immerse yourself in the modern learning space to unleash the best educational journey and interactive academics. State-of-the-art study halls are optimized for learning sessions, featuring smartboards and high-definition projectors to enhance learning engagement. Equipped with a seamless internet connection and advanced experience
      </p>

      <div className="grid grid-cols-1 lg:grid-cols-[1.8fr_2fr] gap-4">
        <div className="relative overflow-hidden shadow-md">
          {activeImages[0] && (
            <div className="relative md:col-span-2 md:row-span-2 h-auto md:h-[600px]">
              <Image
                src={activeImages[0].src}
                alt={activeImages[0].alt}
                width={800}
                height={600}
                className="w-full h-auto md:h-full object-cover"
                priority
              />
              {activeImages[0].isVideo && (
                <div className="absolute inset-0 flex items-center justify-center">
                  <button
                    className="cursor-pointer w-14 h-14 sm:w-16 sm:h-16 rounded-full 
                      bg-white flex items-center justify-center text-[#001C2E] text-2xl"
                    onClick={() => setModal({ open: true, url: activeImages[0].url })}
                  >
                    <span className="inline-flex items-center justify-center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        className="w-10 h-10"
                        fill="black"              // solid black
                      >
                        <path d="M8 5v14l11-7z" />
                      </svg>
                    </span>
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
        <div className="grid grid-cols-2 grid-rows-2 gap-4 overflow-hidden">
          {activeImages.slice(1).map((img, i) => (
            <div key={i} className="relative h-auto md:h-[290px]">
              <Image
                src={img.src}
                alt={img.alt}
                width={400}
                height={300}
                className="w-full h-auto md:h-full object-cover"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ClassroomSection;
